import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import "./styles.css";

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
